const DEFAULT_STABLE_HEX_COLORS = [
  '#FF8D24',
  '#00BA4A',
  '#5278FF',
  '#B179D2',
  '#FF7BB7',
] as const;

const hashString = (value: string) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const cache = new Map<string, string>();

export function getStableHexColor(
  seed?: string,
  palette: readonly string[] = DEFAULT_STABLE_HEX_COLORS,
): string {
  if (palette.length === 0) return '#B179D2';

  const normalizedSeed = seed?.trim() || 'default';
  const cacheKey = `${normalizedSeed}::${palette.join(',')}`;
  const cached = cache.get(cacheKey);
  if (cached !== undefined) return cached;

  const color = palette[hashString(normalizedSeed) % palette.length];
  cache.set(cacheKey, color);
  return color;
}
